import {Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthService } from '../../shared/services/firebase/auth.service';
import { LoginService } from 'src/app/APIservices/registration/login.service';
import { local } from 'd3';
import { AdminGuard } from 'src/app/shared/guard/admin.guard';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { AESService } from 'src/app/APIservices/encryption/aes.service';
type UserFields = 'email' | 'password';
type FormErrors = { [u in UserFields]: string };
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ResetpasswordService } from 'src/app/APIservices/privacy/resetpassword.service';
import {NgxSpinnerService} from "ngx-spinner";
// import { NgbModal, } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('mymodal2', {  static: true }) mymodal2!: any;
  public newUser = false;
  public user: firebase.User;
  public loginForm: FormGroup;
  public formErrors: FormErrors = {
    'email': '',
    'password': '',
  };
  loginBody = {
    "email": "",
    "password": ""
  }
  reset={
    "email": ""
  }
  hide:boolean=false;
  public errorMessage: any;
  closeResult: string;
  show1: any = false;
  password1: string = 'password';
  constructor(private changepass:ResetpasswordService,private modalService: NgbModal,private fb: FormBuilder, private Cryptography: AESService,
    private router: Router, private Reg: LoginService, private guard: AdminGuard, private toast: ToastrService,private ngxSpinnerService:NgxSpinnerService) {
    this.loginForm = fb.group({
      email: ['test@gmail.com', [Validators.required, Validators.email]],
      password: ['test123', Validators.required]
    });
  }

  ngOnInit() {
  }

  // Login With Google
  loginGoogle() {
    //this.authService.GoogleAuth();
  }

  // Login With Twitter
  loginTwitter(): void {
    // this.authService.signInTwitter();
  }

  // Login With Facebook
  loginFacebook() {
    //this.authService.signInFacebok();
  }
  noExist(message= null) {
    Swal.fire({
      title: 'Error!',
      text: message ? message : "User Not Exist",
      icon: 'error',
    })
  }
  successalert() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: 'success',
      title: 'Signed in successfully'
    })
  }
  // Simple Login
  login() {
    if (this.loginForm.valid) {
      this.ngxSpinnerService?.show()
      this.Reg.signin(this.loginBody).subscribe((res) => {
            if (res.status == true) {
              this.ngxSpinnerService?.hide()
              // this.successalert();
              // this.loginWithAbleAdmin()
              // this.router.navigateByUrl('/ecommerce/products');
              this.router.navigate(['/ecommerce/products'])
              this.Cryptography.setItem('accesstoken', res.token, true)
              this.Cryptography.setItem('uid', res.data.id, true)
              this.Cryptography.setItem('name', res.data.username, true)
              this.Cryptography.setItem('fname', res.data.firstname, true)
              this.Cryptography.setItem('lname', res.data.lastname, true)
              this.Cryptography.setItem('email', res.data.email, true)
              this.Cryptography.setItem('address', res.data.address, true)
              this.Cryptography.setItem('cityy', res.data.city, true)
              this.Cryptography.setItem('postal', res.data.postalcode, true)
              this.Cryptography.setItem('country', res.data.country, true)
              this.Cryptography.setItem('role', res.data.Role.rolename, true)
              this.Cryptography.setItem('permissions', JSON.stringify(res.data.Role.rolepermission), true)
              // this.insertpermissions(res.data.rolepermission)
              this.guard.isLoggedIn = true;
              return this.Cryptography.setItem('logvalue', JSON.stringify(this.guard.isLoggedIn), true);

            } else {
              this.ngxSpinnerService?.hide()
              let message = res?.data?.message ? res.data.message :  res?.message
              this.noExist(message)
            }

          },
          (error) =>{
            this.ngxSpinnerService?.hide()
            let message = error?.error?.data?.message ? error?.error?.data?.message :  error?.message
            this.noExist(message)
          } )
    } else {
      this.noExist('Please fill the required fields');
    }

  }

  loginWithAbleAdmin(){
    this.Reg.loginWithClientPortal().subscribe(res=>{
      if(res.status == true){
        this.Cryptography.setItem('clienttoken', res.token, true)
      }
    })
    
  }

  open(content){
    this.hide=false;
  
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true,size:'md'  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason1(reason)}`;
    });
  }

  private getDismissReason1(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  wrong(text?:string) {
    Swal.fire({
      title: 'Error!',
      text: text ? text : 'Email Not Exist',
      icon: 'error',
    })
  }
  success(text?: any) {
    Swal.fire({
      title: 'Success!',
      text: text ? text :'Temporary Password has been sent to this email',
      icon: 'success',
    })
  }
 send(content?: any){
  //  this.hide=true
  this.changepass.resetPass(this.reset).subscribe((res)=>{
    if (res.success) {
      this.success(res?.message);
      this.modalService.dismissAll()
    }else{
      this.wrong(res?.message);
    }
  },
      (err: any)=>{
        console.log(err?.error.message, '<<')
    this.wrong(err?.error.message);
    this.modalService.dismissAll()
  }
  )
 }
  showHidePass1(){
    if (this.password1 === 'password') {
      this.password1 = 'text';
      this.show1 = true;
    } else {
      this.password1 = 'password';
      this.show1 = false;
    }
  }

}
